import React from 'react';
import AppLayout from '../components/ui/AppLayout';
import PageHeader from '../components/ui/PageHeader';
import SectionCard from '../components/ui/SectionCard';
import Prose from '../components/ui/Prose';
import PoliticasDeUso from '../components/politicasUso';

const Politicas = () => (
  <AppLayout maxWidth="md">
    <PageHeader eyebrow="Riviera FC" title="Política de privacidade" />
    <SectionCard>
      <Prose><PoliticasDeUso /></Prose>
    </SectionCard>
  </AppLayout>
);

export default Politicas;
